import { render, staticRenderFns } from "./DocumentsOperationsTab.vue?vue&type=template&id=1e9dce6c&scoped=true"
import script from "./DocumentsOperationsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsOperationsTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsOperationsTab.vue?vue&type=style&index=0&id=1e9dce6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9dce6c",
  null
  
)

export default component.exports